/** Mensagens da timeline: o DTO canônico, o envio e o encaminhamento. */
import { z } from "zod";
import { LIMITS, mediaStatus, messageDirection, messageStatus, messageType } from "../enums.js";
import { cursorPage, uuid } from "./common.js";

/* ---------- Mensagens ---------- */
export const message = z.object({
  id: uuid,
  conversationId: uuid,
  direction: messageDirection,
  type: messageType,
  body: z.string().nullable(),
  mediaId: uuid.nullable(),
  mediaStatus: mediaStatus.nullable(),
  /** Duracao da midia em ms (audio/video), quando o provedor informou. */
  mediaDurationMs: z.number().int().positive().nullable().optional(),
  /** Waveform do WhatsApp: 64 amostras 0..100 em base64. So em audio/voz. */
  waveform: z.string().nullable().optional(),
  deliveryStatus: messageStatus,
  /** Mensagem citada (resposta com contexto). */
  quotedMessageId: uuid.nullable(),
  clientMessageId: z.string().nullable(),
  /** Quem enviou, em grupos. O chat mostra na bolha das recebidas. */
  senderName: z.string().nullable().optional(),
  /** Foto de quem enviou, em grupos — o avatar a esquerda da pilha. */
  senderAvatarUrl: z.string().nullable().optional(),
  /** Apagada no WhatsApp. O conteudo e preservado; a bolha fica esmaecida. */
  revokedAt: z.string().nullable().optional(),
  /** Encaminhada — nossa ou marcada assim por quem mandou. */
  forwarded: z.boolean().optional(),
  externalTimestamp: z.string(),
  createdAt: z.string(),
});
export type Message = z.infer<typeof message>;

/**
 * Encaminhar para outras conversas. O GOWS nao implementa o `forwardMessage`
 * do WAHA (501), entao o conteudo e REENVIADO e a copia nasce marcada como
 * encaminhada — que e o que o WhatsApp mostra de qualquer jeito.
 */
export const forwardMessageInput = z.object({
  conversationIds: z.array(uuid).min(1).max(20),
});
export type ForwardMessageInput = z.infer<typeof forwardMessageInput>;

export const forwardMessageResult = z.object({
  forwarded: z.number().int().nonnegative(),
  failed: z.array(z.object({ conversationId: uuid, reason: z.string() })),
});
export type ForwardMessageResult = z.infer<typeof forwardMessageResult>;

export const messageListInput = cursorPage.extend({
  conversationId: uuid,
});

export const sendMessageInput = z
  .object({
    conversationId: uuid,
    body: z.string().min(1).max(LIMITS.MESSAGE_TEXT_MAX).optional(),
    /** Idempotencia do envio otimista (EC-MSG-002). */
    clientMessageId: z.string().min(8).max(64),
    quotedMessageId: uuid.optional(),
    /** Anexo ja enviado via POST /api/media/uploads. */
    mediaId: uuid.optional(),
    caption: z.string().max(LIMITS.MESSAGE_CAPTION_MAX).optional(),
  })
  .superRefine((d, ctx) => {
    if (!d.body && !d.mediaId) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Envie texto ou anexo.", path: ["body"] });
    }
  });
export type SendMessageInput = z.infer<typeof sendMessageInput>;
